import { Search } from "lucide-react";
import { useShell } from "../../app/shell-context";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);

/**
 * Opens the search dialog (redesign spec §4.5). `field` sits in the page bar and shrinks to an icon on phones;
 * `icon` sits in the document header.
 */
export function SearchTrigger({ variant }: { variant: "field" | "icon" }) {
  const { openSearch } = useShell();
  if (variant === "icon") {
    return (
      <button
        type="button"
        aria-label="Search"
        onClick={openSearch}
        className="grid h-9 w-9 shrink-0 place-items-center rounded-lg text-ink-2 hover:bg-green-wash hover:text-green-ink"
      >
        <Search size={16} aria-hidden="true" />
      </button>
    );
  }
  return (
    <button
      type="button"
      aria-label="Search"
      onClick={openSearch}
      className="flex h-9 w-9 shrink-0 items-center justify-center gap-2 rounded-lg border border-line bg-surface text-sm text-ink-3 hover:border-line-strong md:w-80 md:justify-start md:px-3"
    >
      <Search size={15} aria-hidden="true" />
      <span className="hidden flex-1 truncate text-left md:block">Search everything</span>
      <kbd className="hidden font-mono text-2xs md:block">{isMac ? "⌘K" : "Ctrl K"}</kbd>
    </button>
  );
}
